import { useFormat } from '@ideavivat/vivat-2';

import { target_date, created_at } from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    subType: {
      name: 'ประเภทงานจ้าง',
      width: '6rem',
      filter: (val: string, row: any) => {
        if (row.item.purchase_request.subType === 'CLAIM') return 'เคลม';
        if (row.item.purchase_request.subType === 'SURFACE_TREATMENT') return 'ชุบผิว';
        if (row.item.purchase_request.subType === 'HEAT_TREATMENT') return 'ชุบแข็ง';
        return '';
      },
    },
    code: {
      name: 'รหัสชิ้นส่วน',
      width: '12rem',
      filter: (val: any, row: { item: any }) => `${row.item.material?.code || ''}`,
    },
    material: {
      name: 'วัสดุ',
      width: '1fr',
      filter: (val: any, row: { item: any }) => `${row.item.material?.name || ''}`,
    },
    amount: {
      name: 'จำนวนที่สั่ง / รับแล้ว',
      width: '8rem',
      class: 'text-right mr-2',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // filledAmount: {
    //   name: 'จำนวนที่ได้รับแล้ว',
    //   width: '8rem',
    //   filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    // },
    addedAmount: {
      name: 'จำนวนที่รับ',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    purchase_unit: {
      name: 'หน่วย',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: any, row: { item: any }) => `${val ? val : row.item.material?.unit || ''}`,
    },
    target_date: {
      ...target_date,
      name: 'กำหนดส่ง',
    },
    created_at,
  },
};
